module.exports = "/_next/static/images/InternalSecurity@3x-d14ce5d9a02c48e7678804d75cb00218.webp";